export const VALID_EMAIL_REGEX = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
export const VALID_USER_NAME_REGEX = /^[a-zA-Z\s-]+$/i
export const VALID_COMPANY_NAME_REGEX = /^[a-zA-Z0-9\s-]+$/i
